<!-- // color palette
// 253 253 253   white         #FDFDFD
// 221 221 190   green ish     #DDDDBE
// 231 150 75    light orange  #E7964B
// 215 124 51    darker orange #D77C33
//  23 23 23     almost black  #171717
// https://onlinepngtools.com/ -->
<a href="/#">
  <img src="logo2-white-tsp.png" alt="logo">
</a>
<style>
  img {
    margin: 2px;
    padding: 0;
    height: 72px;
    object-fit: fill;
  }
</style>